/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function Energy24({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="24"
      role="img"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 5c-.77 0-1.387.157-1.917.411-.495.237-.883.548-1.182.788l-.026.02c-.322.258-.55.436-.823.567C2.8 6.906 2.48 7 2 7v2c.77 0 1.387-.157 1.917-.411.495-.237.883-.548 1.182-.788l.026-.02c.322-.258.55-.436.823-.567C6.2 7.094 6.52 7 7 7c.48 0 .8.093 1.052.214.272.13.5.309.823.567l.026.02c.299.24.687.55 1.182.788C10.613 8.843 11.23 9 12 9s1.387-.157 1.917-.411c.495-.237.883-.548 1.182-.788l.026-.02c.322-.258.55-.436.823-.567C16.2 7.094 16.52 7 17 7c.48 0 .8.093 1.052.214.272.13.5.309.823.567l.026.02c.299.24.688.55 1.182.788C20.613 8.843 21.23 9 22 9V7c-.48 0-.8-.093-1.052-.214-.272-.13-.5-.309-.823-.567l-.026-.02c-.299-.24-.687-.55-1.182-.788C18.387 5.157 17.77 5 17 5s-1.387.157-1.917.411c-.495.237-.883.548-1.182.788l-.026.02c-.322.258-.55.436-.823.567C12.8 6.906 12.48 7 12 7c-.48 0-.8-.093-1.052-.214-.272-.13-.5-.309-.823-.567l-.026-.02c-.299-.24-.687-.55-1.182-.788C8.387 5.157 7.77 5 7 5Zm-1.917 5.411C5.613 10.157 6.23 10 7 10s1.387.157 1.917.411c.495.237.883.548 1.182.788l.026.02c.322.258.55.436.823.567.252.12.572.214 1.052.214.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788C15.613 10.157 16.23 10 17 10s1.387.157 1.917.411c.495.237.883.548 1.182.788l.026.02c.322.258.55.436.823.567.252.12.572.214 1.052.214v2c-.77 0-1.387-.157-1.917-.411-.495-.237-.883-.548-1.182-.788l-.026-.02c-.322-.258-.55-.436-.823-.567C17.8 12.094 17.48 12 17 12c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788-.53.254-1.147.411-1.917.411s-1.387-.157-1.917-.411c-.495-.237-.883-.548-1.182-.788l-.026-.02c-.322-.258-.55-.436-.823-.567C7.8 12.094 7.48 12 7 12c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788C3.387 13.843 2.77 14 2 14v-2c.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788Zm0 5C5.613 15.157 6.23 15 7 15s1.387.157 1.917.411c.495.237.883.548 1.182.788l.026.02c.322.258.55.436.823.567.252.12.572.214 1.052.214.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788C15.613 15.157 16.23 15 17 15s1.387.157 1.917.411c.495.237.883.548 1.182.788l.026.02c.322.258.55.436.823.567.252.12.572.214 1.052.214v2c-.77 0-1.387-.157-1.917-.411-.495-.237-.883-.548-1.182-.788l-.026-.02c-.322-.258-.55-.436-.823-.567C17.8 17.094 17.48 17 17 17c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788-.53.254-1.147.411-1.917.411s-1.387-.157-1.917-.411c-.495-.237-.883-.548-1.182-.788l-.026-.02c-.322-.258-.55-.436-.823-.567C7.8 17.094 7.48 17 7 17c-.48 0-.8.093-1.052.214-.272.13-.5.309-.823.567l-.026.02c-.299.24-.687.55-1.182.788C3.387 18.843 2.77 19 2 19v-2c.48 0 .8-.093 1.052-.214.272-.13.5-.309.823-.567l.026-.02c.299-.24.687-.55 1.182-.788Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
